import React from "react";
import { useMutation } from "@apollo/client";
import { SEND_CERTIFICATE } from "../../queries/mutations";
import trophyIcon from "../../assets/images/trophyIcon.png"
import mailIcon from "../../assets/images/mailDownloadIcon.png"

const CertificateBox = ({ name, certificateId }) => {
  const [updateUser] = useMutation(SEND_CERTIFICATE, {
    onCompleted(data) {
      alert("Zertifikat wird per E-Mail an Sie versendet");
    },
    onError: (data) => {
      alert("Leider ist etwas schief gelaufen");
    },
  });

  const handleClick = () => {
    updateUser({
      variables: {
        certificateId: certificateId,
      },
    });
  };

  return (
    <div className="certificate-box">
      <div className="certificate-box-icon">
        <img src={trophyIcon} alt="Trophy" />
      </div>
      <div className="certificate-box-info">
        <span className="certificate-box-title">{`Zertifikat ${name}`}</span>
      </div>
      <div className="certificate-box-download">
        <img src={mailIcon} alt="Download" />
        <span>Download</span>
      </div>
    </div>
  );
};

export default CertificateBox;
